import React from 'react';
import DatePicker from 'material-ui/DatePicker';

const DateTimeFormat = global.Intl.DateTimeFormat;

export default props => (
  <DatePicker
    locale="es"
    DateTimeFormat={DateTimeFormat}
    {...props.inputProps}
    {...props.input}
    value = {props.input.value}
    onChange={(event, value) => {
      props.input.onChange(value);
      if (props.inputProps.onChange) {
        props.inputProps.onChange(value);
      }
      return value;
    }}
  />
);



// WEBPACK FOOTER //
// src/modules/forms/components/DatePicker.js